const readTags = (tags) => Array.isArray(tags)
    ? tags.filter((tag) => typeof tag === 'string')
    : [];
/** Room tags come from LH; desk tags come exclusively from desk analytics. */
export const resolveSpaceTags = (location, analytics, knownDeskIds) => {
    var _a, _b;
    const deskIds = new Set(knownDeskIds);
    const deskMessages = Object.entries(analytics).filter(([, message]) => { var _a; return ((_a = message === null || message === void 0 ? void 0 : message.level) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DESK'; });
    for (const [key, message] of deskMessages) {
        deskIds.add(message.richMapId || key);
    }
    const tagsById = {};
    for (const floor of (_a = location === null || location === void 0 ? void 0 : location.children) !== null && _a !== void 0 ? _a : []) {
        for (const room of (_b = floor.rooms) !== null && _b !== void 0 ? _b : []) {
            if (!deskIds.has(room.richMapId)) {
                tagsById[room.richMapId] = readTags(room.tags);
            }
        }
    }
    for (const id of deskIds)
        tagsById[id] = [];
    for (const [key, message] of deskMessages) {
        tagsById[message.richMapId || key] = readTags(message.tags);
    }
    return tagsById;
};
